module.exports = __webpack_public_path__ + "img/18.b89d3e71.svg";